import React, { useRef } from "react";
import PropTypes from "prop-types";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { SplitButtonDropdown, Button } from "@toddle-edu/ds-web";

import classes from "./CustomLoginButton.scss";

const CustomLoginButton = props => {
  const { buttonText, onClick, icon, isSplitButton, overlay } = props;

  const buttonContainerRef = useRef(null);

  const getWidthOfTheDropDown = () => {
    return buttonContainerRef.current?.offsetWidth;
  };

  return (
    <div ref={buttonContainerRef}>
      <ConditionalWrapper
        condition={isSplitButton}
        wrapper={
          <SplitButtonDropdown
            overlay={
              overlay
                ? React.cloneElement(overlay, {
                    style: { width: `${getWidthOfTheDropDown()}px` },
                  })
                : undefined
            }
            placement="bottomRight"
            className={classes.dropdownContainer}
          />
        }
        type={"wrapperAsElement"}
      >
        <Button
          size={"large"}
          variant="outlined-subtle"
          icon={icon}
          testId={props["data-test-id"]}
          onClick={!isSplitButton ? onClick : () => {}}
          isFullWidth={true}
        >
          {buttonText}
        </Button>
      </ConditionalWrapper>
    </div>
  );
};

CustomLoginButton.displayName = "CustomLoginButton";

CustomLoginButton.defaultProps = {
  innerConStyle: {},
  ["data-test-id"]: "button-custom-login",
};

CustomLoginButton.propTypes = {
  iconUrl: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  innerConStyle: PropTypes.object,
};

export default CustomLoginButton;
